// mds-dojo — dojo/dom-style. get/set computed styles with dojo's semantics:
// get() converts px lengths to numbers, set() accepts (node, name, value) or
// (node, {name: value, …}); "opacity" passes through as number-string.

import dom from './dom';

function toStyleValue(node: any, name: string, value: any): string {
  if (typeof value === 'number') {
    // dojo appends px to dimensional numbers; unitless props stay bare.
    const unitless = /opacity|zIndex|z-index|fontWeight|font-weight|lineHeight|line-height|flexGrow|flexShrink|order/;
    return unitless.test(name) ? String(value) : value + 'px';
  }
  return value == null ? '' : String(value);
}

export function getComputedStyle(node: any): CSSStyleDeclaration {
  const doc = node.ownerDocument || document;
  const view = doc.defaultView || window;
  return view.getComputedStyle(node, null);
}

export function get(node: any, name?: string): any {
  const n = dom.byId(node);
  if (!n) { return null; }
  const cs = getComputedStyle(n);
  if (!name) { return cs; }
  if (name === 'opacity') { return parseFloat(cs.opacity || '1'); }
  const camel = name.replace(/-([a-z])/g, (_m, c) => c.toUpperCase());
  const v: any = (cs as any)[camel];
  // dojo returns pixel NUMBERS for lengths
  if (typeof v === 'string' && /^-?[\d.]+px$/.test(v)) { return parseFloat(v); }
  return v;
}

export function set(node: any, name: string | Record<string, any>, value?: any): any {
  const n = dom.byId(node);
  if (!n) { return null; }
  if (typeof name === 'object') {
    for (const k of Object.keys(name)) { set(n, k, name[k]); }
    return getComputedStyle(n);
  }
  const camel = name.replace(/-([a-z])/g, (_m, c) => c.toUpperCase());
  (n.style as any)[camel] = toStyleValue(n, camel, value);
  return get(n, name);
}

export function toPixelValue(_node: any, value: string): number {
  return parseFloat(value) || 0;
}

const style = { get, set, getComputedStyle, toPixelValue };
export default style;
